import { TranslationObject } from '@ngx-translate/core';

const es: TranslationObject = {
  es: 'Español',
  app: {
    test: 'Esto es una etiqueta de prueba',
    title: 'SWD - Disciplina de Trabajo',
    welcomeMessage: 'Bienvenido a la aplicación web SWD',
    forms: {
      ok: 'Ok',
      cancel: 'Cancelar',
      create: 'Crear',
      continue: 'Continuar',
      labels: {
        businessUnit: 'Unidad de Negocio',
        placeholderBusinessUnit: 'Selecciona una unidad de negocio',
        user: 'Usuario',
        name: 'Nombre',
        description: 'Descripción',
        placeHolderDescription: 'Ingresa una descripción',
        placeHolderReviewType: 'Selecciona un tipo de revisión',
        mandatory: 'Obligatorio',
      },
      unsavedChangesWarning:
        'Se han detectado cambios no guardados. Si abandonas esta página, las modificaciones que realizaste se perderán.<br>¿Deseas continuar?',
    },
    warnings: {
      removeOwnAccess: 'Has eliminado tu acceso. Por favor, actualiza la página web para evitar malfunciones.',
      removeOwnAdminRights:
        'Has eliminado tus derechos de administrador. Por favor, actualiza la página web para evitar malfunciones.',
    },
  },
  navigation: {
    startWorkDone: 'Observaciones',
    category: 'Categorías',
    businessUnits: 'Unidades de Negocio',
    administration: 'Administración',
    sysAdmins: 'Administradores del Sistema',
    users: 'Usuarios',
    areas: 'Áreas',
    errorReductionTools: 'Herramientas de reducción de errores',
  },
  startWorkDoneList: {
    title: 'Observaciones',
    noStartWorkDone:
      'Seleccione una Unidad de Negocio, Área, Sub Área, Categoría y Persona Observada para mostrar registros',
    emptyList: 'No se encontraron registros de Disciplina de Trabajo para los filtros seleccionados',
    id: 'ID',
    question: 'Control',
    answer: 'Respuesta',
    score: 'Puntuación',
    comment: 'Comentario',
    errorReductionTool: 'Herramienta de reducción de errores',
    updatedBy: 'Actualizado Por',
    updatedDate: 'Fecha de Actualización',
    createNewStartWorkDone: 'crear nuevo inicio del trabajo',
    reviewType: 'Tipo de Revisión',
    area: 'Área',
    observationDate: 'Fecha de Observación',
    subArea: 'Sub Área',
    category: 'Categoría',
    placeholderArea: 'Seleccionar un área',
    placeholderSubArea: 'Seleccionar una sub área',
    placeholderCategory: 'Seleccionar una categoría',
    addQuestion: 'Agregar Control',
    description: 'Descripción',
    subSection: 'Sub Sección',
    clearAnswer: 'Limpiar Respuesta',
    deleteQuestion: 'Eliminar Control',
    deleteQuestionTitle: 'Eliminar Control',
    confirmDeleteQuestion:
      '<span>¿Está seguro de que desea eliminar este control?</span><br><br><span><b>Control:</b> {{ description }}</span>',
    editQuestion: 'Editar Control',
    editQuestionHeader: 'Editar Control',
    userSearch: 'Persona Observada',
    userSearchPlaceholder: 'Buscar por nombre o email...',
    supervisor: 'Supervisor',
    noSupervisor: 'No se encontró supervisor',
    generateReport: 'Generar Reporte',
    completeReview: 'Completar y Enviar Reporte',
    generateReportInfoMessage:
      'Su reporte está siendo generado y se descargará automáticamente. Esto puede tardar unos momentos.',
    generateSuccessMessage: 'Reporte generado con éxito',
    reviewSuccessMessage: 'Informe de observación SWD enviado exitosamente',
    sendEmail: 'Enviar Email',
    emailSuccessMessage: 'Email enviado con éxito',
    emailErrorMessage: 'Error al enviar email',
    tableColumns: {
      businessUnit: 'Unidad de Negocio',
      category: 'Categoría',
      subArea: 'Sub Área',
      area: 'Área',
      user: 'Persona Observada',
      supervisor: 'Supervisor',
      observationDate: 'Fecha de Observación',
      totalScore: 'Puntuación Total',
      createdBy: 'Observador',
    },
    viewEdit: 'Ver / Editar',
  },
  startWorkDoneDetail: {
    title: 'Observación',
    details: 'Información General',
    notFound: 'Registro de disciplina de trabajo no encontrado',
    accessDenied: 'No tienes acceso a esta observación.',
    saveSuccess: 'Registro actualizado correctamente',
    editInfo: 'Editar Información',
    saveInfo: 'Guardar Información',
    errorReductionTools: 'Herramientas de reducción de errores',
    noControls: 'No se encontraron controles. Primero agregue controles a esta categoría.',
    totalScore: 'Puntuación Total',
    deleteObservation: 'Eliminar Observación',
    deleteConfirmTitle: 'Eliminar Observación',
    deleteConfirmMessage: '¿Está seguro de que desea eliminar esta observación? Esta acción no se puede deshacer.',
    deleteSuccess: 'Observación eliminada correctamente',
    noObservationDate:
      'No se ha seleccionado ninguna Fecha de Observación. Por favor, seleccione una fecha antes de completar esta revisión.',
  },
  categoryList: {
    title: 'Categorías',
  },
  admin: {
    sysAdminList: {
      title: 'Administradores del Sistema',
      addSysAdmin: 'agregar administrador del sistema',
      fullName: 'nombre completo',
      email: 'email',
      dialogs: {
        removeAccessHeader: 'Confirmación',
        removeAccessMessage:
          '¿Está seguro de que desea eliminar el acceso de administrador del sistema para: [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Unidades de Negocio',
      addBusinessUnit: 'agregar unidad de negocio',
      tableTitle: 'Unidad de Negocio',
      noBusinessUnits: 'No se encontraron unidades de negocio.',
      dialogs: {
        createHeader: 'Crear Unidad de Negocio',
        namePlaceholder: 'Ingrese un nombre',
      },
    },
    businessUnitEdit: {
      title: 'Editar Unidad de Negocio',
    },
    errorReductionTools: {
      title: 'Herramientas de reducción de errores',
      addErt: 'agregar herramienta de reducción de errores',
      tableTitle: 'herramienta de reducción de errores',
      noErts: 'No se encontraron herramientas de reducción de errores.',
      dialogs: {
        createHeader: 'Crear herramienta de reducción de errores',
        editHeader: 'Editar herramienta de reducción de errores',
        namePlaceholder: 'Ingrese un nombre',
        deleteTitle: 'Eliminar herramienta de reducción de errores',
        deleteMessage:
          '¿Está seguro de que desea eliminar la herramienta de reducción de errores <strong>{{name}}</strong>?',
        deleteSuccess: 'Herramienta de reducción de errores eliminada correctamente.',
        deleteConflict:
          'Esta herramienta de reducción de errores no se puede eliminar porque está asociada a uno o más controles.',
      },
    },
    areas: {
      title: 'Áreas',
      areasTitle: 'Áreas',
      subAreasTitle: 'Sub Áreas',
      addArea: 'Agregar Área',
      addSubArea: 'Agregar Sub Área',
      areaName: 'Nombre',
      subAreaName: 'Sub Áreas',
      category: 'Categoría',
      noAreas: 'No hay áreas disponibles.',
      noSubAreas: 'No hay sub áreas disponibles.',
      selectAreaMessage: 'Seleccione un área para gestionar sus sub áreas.',
      dialogs: {
        createAreaHeader: 'Crear Área',
        editAreaHeader: 'Editar Área',
        createSubAreaHeader: 'Crear Sub Área',
        editSubAreaHeader: 'Editar Sub Área',
        namePlaceholder: 'Ingrese un nombre',
        category: 'Categoría',
        categoryPlaceholder: 'Seleccione una categoría (opcional)',
        deleteAreaTitle: 'Eliminar Área',
        deleteAreaMessage: '¿Está seguro de que desea eliminar el área <strong>{{name}}</strong>?',
        deleteAreaLinkedRecords:
          'No se puede eliminar esta área porque tiene registros de Disciplina de Trabajo vinculados.',
        deleteSubAreaTitle: 'Eliminar Sub Área',
        deleteSubAreaMessage: '¿Está seguro de que desea eliminar la sub área <strong>{{name}}</strong>?',
        deleteSubAreaLinkedRecords:
          'No se puede eliminar esta sub área porque tiene registros de Disciplina de Trabajo vinculados.',
      },
    },
  },
  user: {
    requestAccess: {
      title: 'No Registrado',
      forms: {
        submit: 'Solicitar Acceso',
      },
      dialogTitle: 'Solicitar Acceso',
      dialogSubtitle: 'Está por solicitar acceso a  <strong>{{name}}</strong>, desea continuar?',
      reloadWarning:
        'Si visitas esta página pero ya tienes acceso, haz clic en el siguiente enlace para recargar; de lo contrario, contacta con el soporte.',
      reload: 'recargar',
    },
    pendingAccess: {
      title: 'Hola, su solicitud de acceso está en curso',
      reloadWarning:
        'Si visitas esta página pero ya tienes acceso, haz clic en el siguiente enlace para recargar; de lo contrario, contacta con el soporte.',
      reload: 'recargar',
    },
  },
  header: {
    logoAlt: 'Logotipo de CVX',
    userAvatarAlt: 'Avatar del usuario',
    unknownUser: 'Desconocido',
  },
  footer: {
    text: 'Chevron Corporation. Todos los derechos reservados.',
    version: 'SWD v{{ version }}',
  },
  category: {
    title: 'Categorías',
    create: 'Crear',
    name: 'Nombre',
    description: 'Descripción',
    actions: 'Acciones',
    edit: 'Editar',
    manage: 'Administrar',
    delete: 'Eliminar',
    confirmDelete:
      '<span>¿Está seguro de que desea eliminar esta categoría?</span><br><br><span>Nombre: {{ name }}<br>Descripción: {{ description }}</span>',
    noCategories: 'No hay categorías disponibles.',
    titleCreate: 'Crear categoría',
    createNew: 'Crear nuevo',
    selectPlaceholder: 'Seleccione BU',
    titleEdit: 'Editar categoría',
    titleDelete: 'Eliminar categoría',
    deletedSuccessfully: 'Categoría eliminada correctamente',
    importCategory: 'Importar categoría',
    importCategoryTitle: 'Importar categoría a',
    selectCategoryType: 'Seleccionar tipo de categoría',
    confirm: 'Confirmar',
    importSuccessMessage: 'Categoría importada correctamente',
    manageControls: 'Gestionar Controles',
    noControls: 'No hay controles disponibles.',
    selectBusinessUnit: 'Seleccione una unidad de negocio para mostrar los controles',
    importCategoriesTitle: 'Importar Categorías',
    import: 'Importar',
  },
  common: {
    selectAnswer: 'Select answer',
    noAttempt: 'No Attempt',
    needsImprovement: 'Needs Improvement',
    meetsExpectations: 'Meets Expectations',
    exceedsExpectations: 'Exceed Expectations',
    save: 'Guardar',
    businessUnit: 'Unidad de negocio',
    forbidActionErrorMessage: 'El usuario no está autorizado para realizar esta acción.',
    name: 'Nombre',
    code: 'Código',
    cancel: 'Cancelar',
    genericErrorMessage: 'Ha ocurrido un error inesperado. Por favor, inténtelo de nuevo más tarde.',
    savedSuccessfully: 'Guardado con éxito',
    delete: 'Eliminar',
    deletedSuccessfully: 'Eliminado con éxito',
    edit: 'Editar',
    leaveWithOutSaving: 'Salir sin guardar',
    language: 'Idioma',
    view: 'Ver',
    back: 'Volver',
    createdBy: 'Creado por',
    updatedBy: 'Actualizado por',
    updatedDate: 'Fecha de actualización',
    errors: {
      failedToSubmit: 'No se pudo enviar la respuesta. Por favor, inténtelo de nuevo.',
    },
  },
  serverError: {
    title: 'Servidor no disponible',
    message:
      'No se puede conectar con el servidor. Por favor, verifique su conexión de red o inténtelo de nuevo más tarde.',
    returnHome: 'Volver al inicio',
  },
  pageNotFound: {
    title: 'Página no encontrada',
    message: 'La página que busca no existe.',
    returnHome: 'Volver al inicio',
  },
  unauthorized: {
    title: 'Acceso no autorizado',
    message: 'No tiene permiso para acceder a esta página.',
    returnHome: 'Volver al inicio',
  },
  categoryManage: {
    title: 'Manejar Contenido de [{{ description }}]',
    questionsTitle: 'Controles',
    addQuestionAction: 'agregar control',
    questionName: 'Control',
    questionNamePlaceholder: 'Ingrese el texto del control',
    errorReductionTools: 'Herramientas de reducción de errores',
    ertPlaceholder: 'Seleccione herramientas de reducción de errores',
    noQuestions: 'No se encontraron controles. Agregue un control para comenzar.',
    sectionsTitle: 'Secciones',
    subSectionsTitle: 'Subsecciones',
    addSectionAction: 'agregar sección',
    mandatoryLabel: 'Obligatorio',
    createNewSubsectionAction: 'añadir grupo de controles',
    emptySubSectionsMessage:
      '<p>No hay contenido disponible para esta sección.</p><p>Por favor, agregue una subsección para comenzar.</p>',
    itemDescriptionTableHeader: 'Descripción',
    createNewItemAction: 'Agregar control',
    createSectionHeader: 'Crear Sección',
    editSectionHeader: 'Editar Sección',
    confirmDeleteSection: '¿Está seguro de que desea eliminar la sección <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Añadir grupo de controles',
    editSubSectionHeader: 'Editar subsección',
    createQuestionTitle: 'Crear control',
    ShouldAddCommentToQuestion: 'El usuario debe añadir un comentario a cualquier control respondido con N/D',
    deleteQuestionTitle: 'Eliminar control',
    confirmDeleteQuestion:
      '<span>¿Está seguro de que desea eliminar este control?</span><br><br><span><b>Descripción:</b> {{ description }}</span>',
    confirmDeleteSubSection: '¿Está seguro de que desea eliminar la subsección <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Eliminar Sección',
    deleteSubSectionHeader: 'Eliminar Subsección',
    editQuestionTitle: 'Editar control',
    defaultSubSectionName: 'Controles',
  },
  paginator: {
    previous: 'Anterior',
    next: 'Siguiente',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} de {{totalRecords}}',
  },
  usersList: {
    title: 'Usuarios',
    forms: {
      displayInactiveUsers: 'mostrar usuarios inactivos',
    },
    actions: {
      addNewUser: 'Agregar nuevo usuario',
      grantAccess: 'conceder acceso',
    },
    table: {
      fullName: 'nombre completo',
      email: 'email',
      admin: 'admin',
    },
    noUsers: 'No hay usuarios disponibles',

    dialogs: {
      removeAccessHeader: 'Confirmación',
      removeAccessMessage: '¿Estás seguro de que deseas eliminar el acceso para: [{{fullName}}]?',
    },
  },
  actionItems: {
    id: 'ID',
    title: 'Elementos de Acción',
    addActionItem: 'agregar elemento de acción',
    actionTitle: 'Título',
    assignee: 'Responsable',
    date: 'Fecha',
    comment: 'Comentario',
    priority: 'Prioridad',
    configureActionItem: 'Configurar elementos de acción',
    dialogs: {
      configureActionItem: 'Configurar items de acción',
      configureComment: 'Comentario',
      deleteActionItemHeader: 'Borrar item de acción',
      deleteActionItemMessage: 'Confirma que desea realizar esta acción?',
    },
  },
  comments: {
    title: 'Comentarios',
    comment: 'Comentario',
    addComment: 'Agregar Comentario',
    noComments: 'Sin comentarios',
    dialogs: {
      configureComment: 'Comentario',
      deleteCommentHeader: 'Borrar Comentario',
      deleteCommentMessage: 'Confirma que desea realizar esta acción?',
    },
    instructions: {
      title: 'Los comentarios deben incluir:',
      observed: 'Qué se observó',
      coaching: 'Qué entrenamiento se proporcionó',
      action: 'Qué acción se tomó para resolver los problemas',
      feedback: 'Qué retroalimentación positiva se dio por superar las expectativas',
    },
  },
  features: {
    startWorkDone: {
      labels: {
        observationComment: 'Comentario de Observación',
      },
      placeholders: {
        enterComment: 'Ingresa tu retroalimentación de coaching o contexto para esta respuesta...',
      },
      messages: {
        responseSubmitted: 'Respuesta enviada exitosamente',
        commentRequired: 'Se requiere un comentario para este tipo de respuesta',
      },
      responseAnswers: {
        noAttempt: 'Sin Intento',
        needsImprovement: 'Necesita Mejora',
        meetsExpectations: 'Cumple Expectativas',
        exceedsExpectations: 'Supera Expectativas',
        notApplicable: 'No Aplica',
      },
    },
  },
};
export default es;
